<!-- <form class="form-group odd" id="category_name_field_box">
  <label
    class="col-sm-3 control-label"
    for="name"
    id="category_name_display_as_box"
  >
    <font style="vertical-align: inherit">
      <font style="vertical-align: inherit">
        {{ categoryI18n?.category_nameI18n }}
      </font> </font
    ><span class="required">
      <font style="vertical-align: inherit">
        <font style="vertical-align: inherit">*</font>
      </font>
    </span>
  </label>
  <div class="col-sm-9 col-md-6 col-lg-6" id="category_name_input_box">

    <input
      [(ngModel)]="model.category_name"
      id="field-category_name"
      value="{{ model.category_name }}"
      name="category_name"
      class="form-control"
      type="text"
      maxlength="99"
    />
    <br />

    <button (click)="edit()" type="button" class="btn btn-info">
      <i class="fas fa-save"></i>
      {{ categoryI18n?.editButtonI18n }}
    </button>
  </div>
</form>
 -->

<!-- Category Edit Modal -->
<div class="modal-header">
  <h5 class="modal-title">
    {{ category?.id ? categoryI18n?.editCategoryI18n || 'Chỉnh sửa danh mục' : categoryI18n?.addCategoryI18n || 'Thêm danh mục' }}
  </h5>
  <button type="button" class="close" aria-label="Close" (click)="onCancelClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form #categoryForm="ngForm">
    <!-- Category Name Field -->
    <div class="form-group row odd" id="category_name_field_box">
      <label
        class="col-sm-3 control-label"
        for="categoryName"
        id="category_name_display_as_box"
      >
        <span>
          {{ categoryI18n?.categoryNameI18n || 'Tên danh mục' }}
        </span>
        <span class="required">*</span>
        <i
          class="fas fa-info-circle ml-2"
          data-toggle="tooltip"
          data-html="true"
          title="<b>{{ categoryI18n?.descriptionI18n || 'Mô tả' }}:</b> {{ categoryI18n?.descriptionTextI18n || 'Nhập tên danh mục.' }}<br><b>{{ categoryI18n?.exampleI18n || 'Ví dụ' }}:</b> Điện tử, Quần áo"
          aria-label="Category Name Information"
        ></i>
      </label>
      <div class="col-sm-9 col-md-6 col-lg-6" id="category_name_input_box">
        <!-- Input with Suggestions Button -->
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            id="categoryName"
            [(ngModel)]="category.category_name"
            name="categoryName"
            placeholder="{{ categoryI18n?.placeholderI18n || 'ví dụ: Điện tử, Quần áo' }}"
            maxlength="99"
            required
            #categoryName="ngModel"
          />
        </div>
        <!-- Validation Message -->
        <div *ngIf="categoryName.invalid && (categoryName.dirty || categoryName.touched)" class="text-danger mt-1">
          {{ categoryI18n?.requiredMessageI18n || 'Tên danh mục là bắt buộc.' }}
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <div class="col-sm-12 text-right">
    <button type="button" class="btn btn-outline-secondary mr-2" (click)="onCancelClick()">
      {{ categoryI18n?.cancelButtonI18n || 'Hủy' }}
    </button>
    <button
      type="button"
      class="btn btn-outline-primary"
      (click)="saveCategory()"
      [disabled]="categoryForm.invalid"
    >
      <i class="fas fa-save"></i> {{ categoryI18n?.saveButtonI18n || 'Lưu' }}
    </button>
  </div>
</div>

